module.exports = __webpack_public_path__ + "static/clippy-trailer-bc01152a63b4c115cffaa468dfe4d400.mp4";